'use client'

import Link from "next/link";

import { usePathname } from "next/navigation";

// import IconTabHome from "@/assets/icon/tab-home.svg";
// import IconTabHomeActive from "@/assets/icon/tab-home--active.svg";
import IconTabDashboard from "@/assets/icon/tab-dashboard.svg";
import IconTabDashboardActive from "@/assets/icon/tab-dashboard--active.svg";
import IconTabEvents from "@/assets/icon/tab-events.svg";
import IconTabEventsActive from "@/assets/icon/tab-events--active.svg";
// import IconTabNews from "@/assets/icon/tab-news.svg";
// import IconTabNewsActive from "@/assets/icon/tab-news--active.svg";
import IconTabPoll from "@/assets/icon/tab-poll.svg";
import IconTabPollActive from "@/assets/icon/tab-poll--active.svg";
import IconTabPush from "@/assets/icon/tab-push.svg";
import IconTabPushActive from "@/assets/icon/tab-push--active.svg";
import {useAbility} from "@/app/pwa/lib/ability-context";
import { pwaAllNewsPath, pwaEventsPath, pwaNotificationsPath, pwaPollsPath } from "@/utils/urlHelper";

export default function ContentTabBar() {
  const ability = useAbility();
  const pathname = usePathname();
  const DashboardIsActive = pathname === "/";
  const EventsIsActive = pathname === pwaEventsPath() ;
  const NewsIsActive = pathname === pwaAllNewsPath() ;
  const PollsIsActive = pathname === pwaPollsPath() ;
  const PushIsActive = pathname === pwaNotificationsPath();

  return <footer className="pl-max-5-or-safe-area-inset-left pr-max-5-or-safe-area-inset-right pb-max-3-or-safe-area-inset-bottom fixed z-40 bottom-0 left-0 right-0 bg-surface shadow-[0_-2px_10px_0_rgba(0,0,0,0.08),_0_-1px_3px_0_rgba(0,0,0,0.05)] lg:hidden">
    <div className="flex items-baseline justify-around @container">
      <Link className={`content-tab-bar__link ${DashboardIsActive ? "" : "opacity-50"} flex items-center flex-col flex-1 pt-1`} href="/">
        <div className="content-tab-bar__icon">{ DashboardIsActive ? <IconTabDashboardActive /> : <IconTabDashboard />}</div>
        <div className="text-xs xs:text-sm font-compressed uppercase">Dashboard</div>
      </Link>
      <Link className={`content-tab-bar__link ${EventsIsActive ? "" : "opacity-50"} flex items-center flex-col flex-1 pt-1`} href={pwaEventsPath()}>
        <div className="content-tab-bar__icon">{ EventsIsActive ? <IconTabEventsActive /> : <IconTabEvents />}</div>
        <div className="text-xs xs:text-sm font-compressed uppercase">Termine</div>
      </Link>
      {/* <Link className={`content-tab-bar__link ${NewsIsActive ? "" : "opacity-50"} flex items-center flex-col flex-1 pt-1`} href={pwaAllNewsPath()}>
        <div className="content-tab-bar__icon">{ NewsIsActive ? <IconTabNewsActive /> : <IconTabNews />}</div>
        <div className="text-xs xs:text-sm font-compressed uppercase">Neuigkeiten</div>
      </Link> */}
      {ability.can('list', 'Poll') && 
        <Link className={`content-tab-bar__link ${PollsIsActive ? "" : "opacity-50"} flex items-center flex-col flex-1 pt-1`} href={pwaPollsPath()}>
          <div className="content-tab-bar__icon">{ PollsIsActive ? <IconTabPollActive /> : <IconTabPoll />}</div>
          <div className="text-xs xs:text-sm font-compressed uppercase">Abstimmungen</div>
        </Link>
      }
      {ability.can('list', 'Notifications') && 
        <Link className={`content-tab-bar__link ${PushIsActive ? "" : "opacity-50"} flex items-center flex-col flex-1 pt-1`} href={pwaNotificationsPath()}>
          <div className="content-tab-bar__icon">{ PushIsActive ? <IconTabPushActive /> : <IconTabPush />}</div>
          <div className="text-xs xs:text-sm font-compressed uppercase">
            {/* <span className="lg:non">Benachricht.</span> */}
            <span>Benachrichtigungen</span>
          </div>
        </Link>
      }
    </div>

  </footer>
}
